import { dmsActions, useDmsDispatch } from '@packages/contexts/dms';
import { useEffect } from 'react';
import { useMatch } from 'react-router-dom';

export const DmsVinSync: React.FC = () => {
    const dmsDispatch = useDmsDispatch();
    const vinMatch = useMatch('/vin/:vin/*');
    const vinParam = vinMatch?.params?.vin;

    useEffect(() => {
        dmsDispatch(dmsActions.clearDmsData());
    }, [dmsDispatch, vinParam]);

    return null;
};
